<template>
  <div class="col-xs-12 col-sm-6 flex-column-center">
    <h4>
      Tempo médio de agendamento de {{ title }}<br />
      <small>(últimos 6 meses)</small>
    </h4>
    <div class="chartWrapper">
      <PieChart :chartData="chartData" :options="options" />
    </div>
  </div>
</template>

<script>
import { PieChart } from '../common'
import { request } from '../../request'
import colors from '../../utils/colors'

export default {
  components: {
    PieChart
  },
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dados: { datasets: [] },
      options: {
        responsive: true,
        title: {
          display: true,
          text: `Quantidade de ${this.title}`,
          position: 'bottom'
        },
        tooltips: this.getToolTip(this.title),
        plugins: {
          datalabels: {
            color: ['#697473', '#FFF', '#697473', '#FFF', '#FFF', '#FFF'],
            font: {
              size: 20
            },
            align: 'end',
            display: false
          }
        }
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    getToolTip(value) {
      return {
        callbacks: {
          label: function(tooltip, dataset) {
            const { index } = tooltip
            const { data } = dataset.datasets[0]
            const label = dataset.labels[index]

            return `${label}: ${data[index]} ${value}`
          }
        }
      }
    },
    fetchData() {
      request
        .get(this.apiUrl)
        .then(response => {
          const { data } = response

          const medias = data.map(item => {
            return Number(item.media).toFixed(0)
          })

          this.setMedias(medias)
        })
        .catch(error => {
          const { response } = error
          console.log(response)
          this.$toastr.e(
            `Houve um errro ao carregar as estatísticas. Atualize a página e tente novamente`
          )
        })
    },
    mediaReducer: (acum, atual) => {
      const value = Number(atual)
      switch (true) {
        // case value < 15:
        //   acum.quinze++
        //   break
        // case value < 30:
        //   acum.trinta++
        //   break
        // case value < 45:
        //   acum.quarentacinco++
        //   break
        // case value < 60:
        //   acum.sessenta++
        //   break
        // case value < 75:
        //   acum.setentacinco++
        //   break
        case value <= 90:
          acum.noventa++
          break
        default:
          acum.mais++
          break
      }

      return acum
    },
    setMedias(medias) {
      const {
        // quinze,
        // trinta,
        // quarentacinco,
        // sessenta,
        // setentacinco,
        noventa,
        mais
      } = medias.reduce(this.mediaReducer, {
        // quinze: 0,
        // trinta: 0,
        // quarentacinco: 0,
        // sessenta: 0,
        // setentacinco: 0,
        noventa: 0,
        mais: 0
      })

      const datasets = [
        {
          data: [
            // quinze,
            // trinta,
            // quarentacinco,
            // sessenta,
            // setentacinco,
            noventa,
            mais
          ],
          backgroundColor: [...colors.coresHexa]
          // backgroundColor: [
          //   '#0ba81f',
          //   '#3c8e21',
          //   '#6d7323',
          //   '#9d5925',
          //   '#ce3e27',
          //   '#ff2429'
          // ]
        }
      ]

      this.dados = {
        labels: [
          // 'Até 15 dias',
          // 'Até 30 dias',
          // 'Até 45 dias',
          // 'Até 60 dias',
          // 'Até 75 dias',
          '0 a 90 dias',
          'Acima de 90 dias'
        ],
        datasets
      }
    }
  },
  computed: {
    chartData() {
      return this.dados
    }
  }
}
</script>

<style scoped>
.flex-column-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

h4 {
  text-align: center;
}

.chartWrapper {
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProcedimentosSaude/EstatisticaTempoMedio.vue